import { SET_TARGET } from '../actions';
import { reduxStoreTypes } from '@type/redux-store';

const target = (target:string = '', action: reduxStoreTypes.TargetAction) => {
    if (action.type === SET_TARGET) {
        return action.target
    }
    return target
}
export default target